import { JSONAPIRequestProcessor } from "@orbit/jsonapi";
import { UnauthorizedError } from "lib/errors/UnauthorizedError";

export class WrappedJSONAPIRequestProcessor extends JSONAPIRequestProcessor {
  protected async handleFetchResponseError(
    response: Response,
    data?: unknown
  ): Promise<Error> {
    if(response.status == 401) {
      throw new UnauthorizedError(response)
    }
    return super.handleFetchResponseError(response, data)
  }
}
